import { Pipe, PipeTransform, Injectable, inject } from '@angular/core';
import AppLanguageService from '../services/app-language.service';
import DictionaryService from '../services/dictionary.service';

@Pipe({ name: 'translateUnauthenticated', standalone: true, pure: false })
@Injectable({providedIn: 'root'})
export class TranslateUnauthenticatedPipe implements PipeTransform {
	private dictionaryService: DictionaryService = inject(DictionaryService);
	private appLanguageService: AppLanguageService = inject(AppLanguageService);
	
	activeLocale: any = undefined;
	
	constructor() {}

	transform(path) {		
		var localeQueryParam: any = this.getParameterByName("locale");
		var sessionStorageLocale = window.sessionStorage.getItem("locale");
		var locale: any = localeQueryParam ? localeQueryParam : sessionStorageLocale;
		if (locale === 'null' || !locale) {
			locale = 'en_GB';
		}
		locale = this.appLanguageService.normalizeLocale(locale);
		if (locale !== this.activeLocale) {
			this.activeLocale = locale;
			this.dictionaryService.setLanguage(locale).catch(() => {});
		}
		return this.dictionaryService.translate(path, locale);
	}
	
	getParameterByName(name) {
		var url: any = window.location.href;
		name = name.replace(/[\[\]]/g, '\\$&');
		var regex: any = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}
	
}
